module.exports = __webpack_public_path__ + "static/media/3.ae83b342.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairback/3.png
// module id = 661
// module chunks = 0